import { CSSProperties } from "react"
import { colors, fonts } from "../Styles"

export enum FieldTypes {
  primaryInputField = "primaryInputField",
  shortInputField = "shortInputField",
  mediumInputField = "mediumInputField", // slet når inputfield er klaret
  editField = "editField",
  popoverDropdown = "popoverDropdown"
}
  
export const CreateFieldTypes = (fieldType?:FieldTypes|string) => {
  let height
  let width
  let dropdownBorderRadius
  let dropdownBorder
  let textpadding
  let distancePaddingInput
  let distancePaddingSelect
  let enhancerPadding
  let arrowMargin
  let optionContentMargin
  let dropdownWidth
  let optionContentWidth
  let popoverBorderRadius
  let popoverWidth
  let popoverTop
  let popoverPosition
  let dropdownListItemWidth
  let dropdownBoxShadow
  let showSelectArrow
  let controleContainerBorderRadiusOpen

  switch (fieldType) {
    case 'editField':
      height = "25px"
      width = "100%"
      dropdownBorderRadius = "0px 10px 10px 10px"
      dropdownBorder = "none"
      textpadding = "0px"
      distancePaddingInput = "0px"
      distancePaddingSelect = "0px 0px 0px 3px"
      enhancerPadding = "0px 5px 0px 0px"
      arrowMargin = "-12px"
      optionContentMargin = "0px 10px"
      optionContentWidth = "220px"
      dropdownWidth = "280px"
      popoverBorderRadius = "0px"
      popoverWidth = "auto"
      popoverTop = "0px"
      popoverPosition = "absolute"
      dropdownListItemWidth = "auto"
      dropdownBoxShadow = "0 5px 5px"+colors.blackPrimary+("4d")
      showSelectArrow = "block"
      controleContainerBorderRadiusOpen = "10px 10px 0 0"
    break;
    case 'shortInputField':
      height = "30px"
      width = "137.5px"
      dropdownBorderRadius = "0 0 10px 10px"
      dropdownBorder = "none"
      textpadding = "0px"
      distancePaddingInput = "0px 0px 0px 20px"
      distancePaddingSelect = "0px 0px 0px 60px"
      enhancerPadding = "0px 8px"
      arrowMargin = "0px"
      optionContentMargin = "0px"
      optionContentWidth = "90px"
      dropdownWidth = "137.5px"
      popoverBorderRadius = "0px"
      popoverWidth = "137.5px"
      popoverTop = "0px"
      popoverPosition = "relative"
      dropdownListItemWidth = "auto"
      dropdownBoxShadow = "0 5px 5px"+colors.blackPrimary+("4d")
      showSelectArrow = "block"
      controleContainerBorderRadiusOpen = "10px 10px 0 0"
    break;
    case 'mediumInputField':
      height = "30px"
      width = "180px"
      dropdownBorderRadius = "0 0 10px 10px"
      dropdownBorder = "none"
      textpadding = "0px 14px"
      distancePaddingInput = "0px 0px 0px 20px"
      distancePaddingSelect = "0px 0px 0px 60px"
      enhancerPadding = "0px 8px"
      arrowMargin = "0px"
      optionContentMargin = "0px"
      optionContentWidth = "90px"
      dropdownWidth = "137.5px"
      popoverBorderRadius = "0px"
      popoverWidth = "137.5px"
      popoverTop = "0px"
      popoverPosition = "relative"
      dropdownListItemWidth = "auto"
      dropdownBoxShadow = "0 5px 5px"+colors.blackPrimary+("4d")
      showSelectArrow = "block"
      controleContainerBorderRadiusOpen = "10px 10px 0 0"
    break;
    case 'popoverDropdown':
      height = "30px"
      width = "280px"
      dropdownBorderRadius = "10px"
      dropdownBorder = "3px solid"+colors.blueDarkPrimary
      distancePaddingSelect = "0px 0px 0px 60px"
      arrowMargin = "0px"
      optionContentMargin = "0px 6px"
      optionContentWidth = "145px"
      dropdownWidth = "200px"
      popoverBorderRadius = "10px"
      popoverWidth = "200px"
      popoverTop = "-50px"
      popoverPosition = "absolute"
      dropdownListItemWidth = "auto"
      dropdownBoxShadow = "0 0px 5px 1px"+colors.blackPrimary+("4d")
      showSelectArrow = "none"
      controleContainerBorderRadiusOpen = "10px"
    break;
    default:
    case 'primaryField':
      height = "30px"
      width = "280px"
      dropdownBorderRadius = "0 0 10px 10px"
      dropdownBorder = "none"
      // textpadding = "0px 14px"
      textpadding = "0px"
      distancePaddingInput = "0px 0px 0px 20px"
      distancePaddingSelect = "0px 0px 0px 60px"
      enhancerPadding = "0px 8px"
      arrowMargin = "0px"
      optionContentMargin = "0px"
      optionContentWidth = "250px"
      dropdownWidth = "280px"
      popoverBorderRadius = "0px"
      popoverWidth = "280px"
      popoverTop = "0"
      popoverPosition = "relative"
      dropdownListItemWidth = "250px"
      dropdownBoxShadow = "0 5px 5px"+colors.blackPrimary+("4d")
      showSelectArrow = "block"
      controleContainerBorderRadiusOpen = "10px 10px 0 0"
    break;
  }
  
  return { 
    height, 
    width, 
    dropdownBorderRadius, 
    dropdownBorder,
    textpadding, 
    distancePaddingInput, 
    distancePaddingSelect, 
    enhancerPadding, 
    arrowMargin, 
    optionContentMargin,
    optionContentWidth,
    dropdownWidth,
    popoverBorderRadius,
    popoverWidth,
    popoverTop,
    popoverPosition,
    dropdownListItemWidth,
    dropdownBoxShadow,
    showSelectArrow,
    controleContainerBorderRadiusOpen
  }
}